// common images links
import { MEDIA_CENTRAL_LINKS } from './common';

// images stored locally
const DETAILED_IMAGE_BACK_ICON = require('@/assets/images/svg/Detailed_Image_Back_ICON.svg');
const GATEWAY_TOP_SEARCH_ICON = require('@/assets/images/svg/landingPage/Gateway_Top_Search_English.png');

// images stored in formal MEDIA_CENTRAL GSAPP directory
const NO_DATA_IMAGE = `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}10_Assets/01_DummyImage/DummyImage_Asin_list_01_3x.png`;
const LANDING_SEARCH = `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}10_Assets/03_LandingPage/Landing_search_3x.png`;
const DP_ARROW_ICON = `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}10_Assets/00_Toolkits/Toolkits_DP_Arrow_L_3x.png`;
const TOOLKITS_SEARCH = `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}10_Assets/00_Toolkits/Toolkits_Search_3x.png`;
const BRANDSTORE_BACK_WHITE = `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}10_Assets/00_Toolkits/Toolkits_Brandstore_Back_White_3x.png`;
const LANDING_SCREEN = `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}10_Assets/00_Toolkits/Toolkits_Landing_Screen_3x.png`;
const BRANDSTORE_SHARE = `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}10_Assets/00_Toolkits/Toolkits_Brandstore_Share_3x.png`;
const LANDING_SCREEN_SELECTED = `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}10_Assets/00_Toolkits/Toolkits_Landing_screen_selected_3x.png`;
const EMPTYLIST_ADDRESS = `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}01_Emptylist/Emptylist_Address.png`;
const SUCCESS_ICON_IMAGE_URL = `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}10_Assets/00_Toolkits/Toolkits_Changeover_success_3x.png`;

// Todo: need to be uploaded to MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL
const SEARCH_CLOSE = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/searchClose.svg`;
const FORWARDING = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/forwarding.svg`;
const SLIDING_ARROW = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/slidingArrow.svg`;
const WHITE_SLIDING_ARROW = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/whiteSlidingArrow.svg`;
const NO_REVIEW_IMAGE = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/image/noReview.png`;
const EMPTY_LIST = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/image/emptyList.png`;
const BLACK_SHARE_ICON = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/toDayDealShare.svg`;
const UPARROW = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/image/icons/uparrow.png`;
const STROKE = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/detailTags/stroke.svg`;
const CART_EMPTY = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/image/cart-empty.png`;
const NOT_SELECTED = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}/assets/svg/notSelected.svg`;
const SELECTED = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}/assets/svg/selected.svg`;
const RIGHT_ARROW_BLACK = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/image/icons/rightArrowBlack.svg`;
const PRICE_REDUCTION_ICON = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/priceReductionIcon.png`;
const SHARE_WHITE = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/shareWhite.svg`;
const DELETE = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/delete.svg`;
const ICON_BACK = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/IconBack.svg`;
const VECTOR = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/vector.svg`;
const DOWN_ARROW = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/image/icons/downArrow.png`;
const YELLOW_ARROW_RIGHT = `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/image/icons/yellowArrowRight.png`;

export const ASIN_ITEM_ICONS_URLS = {
  US_BADGE: `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`,
  UK_BADGE: `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`,
  JP_BADGE: `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`,
  GE_BADGE: `${MEDIA_CENTRAL_LINKS.NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`,
  DOTD: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/DOTD.svg`,
  OP: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/OverseasPurchase.svg`
};

export default {
  VECTOR,
  DELETE,
  STROKE,
  UPARROW,
  SELECTED,
  ICON_BACK,
  CART_EMPTY,
  DOWN_ARROW,
  SHARE_WHITE,
  NOT_SELECTED,
  NO_DATA_IMAGE,
  NO_REVIEW_IMAGE,
  RIGHT_ARROW_BLACK,
  YELLOW_ARROW_RIGHT,
  PRICE_REDUCTION_ICON,
  SEARCH_CLOSE,
  DP_ARROW_ICON,
  EMPTY_LIST,
  TOOLKITS_SEARCH,
  BRANDSTORE_BACK_WHITE,
  LANDING_SCREEN,
  BRANDSTORE_SHARE,
  LANDING_SCREEN_SELECTED,
  LANDING_SEARCH,
  FORWARDING,
  DETAILED_IMAGE_BACK_ICON,
  SLIDING_ARROW,
  WHITE_SLIDING_ARROW,
  BLACK_SHARE_ICON,
  EMPTYLIST_ADDRESS,
  GATEWAY_TOP_SEARCH_ICON,
  SUCCESS_ICON_IMAGE_URL
};
